import { Input } from 'antd';

import { Form, StyledModal } from 'common/components';
import { QaSpecHelpContentLabel } from 'pages/qa-spec/components/shared/QaSpecHelpContent';

import { PRODUCT_SPEC_LIMIT_CHARACTERS } from 'pages/qa-spec/constant';
import TraceableCommentContainer from 'pages/traceable-comment/TraceableCommentContainer';
import { TOOlTIP_FIELDS } from 'static/tooltipFields';
import { getFormattedPath } from '../shared/QaSpecHelper';

const ModalUpdateProductDocument = ({ formInstance, ...otherProps }) => {
  return (
    <StyledModal title='Update Document' {...otherProps}>
      <Form
        form={formInstance}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
      >
        <Form.Item
          label={
            <TraceableCommentContainer
              qaSpecName={getFormattedPath(
                TOOlTIP_FIELDS.documentName.fieldPath
              )}
              qaSpecFieldName='Document Name'
            >
              <QaSpecHelpContentLabel
                fieldPath={TOOlTIP_FIELDS.documentName.fieldPath}
              >
                Document Name
              </QaSpecHelpContentLabel>
            </TraceableCommentContainer>
          }
          name='documentName'
        >
          <Input />
        </Form.Item>
        <Form.Item
          label={
            <TraceableCommentContainer
              qaSpecName={getFormattedPath(
                TOOlTIP_FIELDS.characteristicType.fieldPath
              )}
              qaSpecFieldName='Characteristics Type'
            >
              <QaSpecHelpContentLabel
                fieldPath={TOOlTIP_FIELDS.characteristicType.fieldPath}
              >
                Characteristics Type
              </QaSpecHelpContentLabel>
            </TraceableCommentContainer>
          }
          name='characteristicsType'
        >
          <Input
            showCount
            maxLength={
              PRODUCT_SPEC_LIMIT_CHARACTERS.document.characteristicsType
            }
          />
        </Form.Item>
      </Form>
    </StyledModal>
  );
};

export default ModalUpdateProductDocument;
